import React from "react";
import { Search } from "lucide-react";

const INPUT = "mt-1.5 w-full px-3 py-2 rounded-md border border-slate-200 text-sm bg-white";

export const PolicyFilters = ({ filters, onChange, categories, homes, statuses, privileged, count }) => {
  const set = (k) => (e) => onChange({ ...filters, [k]: e.target.value });
  return (
    <div className="nv-card p-4" data-testid="policy-filters">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-3">
        <label className="md:col-span-5 text-xs font-semibold text-slate-600">
          Search title, owner, description or document text
          <div className="relative">
            <Search size={15} className="absolute left-3 top-[18px] text-slate-400" />
            <input value={filters.q} onChange={set("q")} placeholder="e.g. medication, incident, visitor…"
              className={`${INPUT} pl-9`} data-testid="policy-search-input" />
          </div>
        </label>
        <label className="md:col-span-3 text-xs font-semibold text-slate-600">Category
          <select value={filters.category} onChange={set("category")} className={INPUT} data-testid="policy-filter-category">
            <option value="">All categories</option>
            {categories.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
          </select>
        </label>
        <label className="md:col-span-2 text-xs font-semibold text-slate-600">Home
          <select value={filters.home} onChange={set("home")} className={INPUT} data-testid="policy-filter-home">
            <option value="">All homes</option>
            {homes.map((h) => <option key={h} value={h}>{h}</option>)}
          </select>
        </label>
        <label className="md:col-span-2 text-xs font-semibold text-slate-600">Status
          <select value={filters.status} onChange={set("status")} className={INPUT} data-testid="policy-filter-status">
            <option value="">{privileged ? "All (excl. archived)" : "Active"}</option>
            {statuses.filter((s) => privileged || s === "Active").map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </label>
      </div>
      <p className="mt-3 text-xs text-slate-500" data-testid="policy-result-count">{count} polic{count === 1 ? "y" : "ies"} match</p>
    </div>
  );
};
